module.exports = __webpack_public_path__ + "img/i_01.fd319ddf.png";